export default "__VITE_ASSET__e594be76__"